/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export class Admin {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List All Organizations.
   *
   * @tags Admin
   * @name ListAllOrganizations
   * @summary List All Organizations
   * @request GET:/api/admin/organizations
   * @secure
   */
  listAllOrganizations = (params = {}) =>
    this.http.request({
      path: `/api/admin/organizations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Organization Data.
   *
   * @tags Admin
   * @name GetOrganizationData
   * @summary Get Organization Data
   * @request GET:/api/admin/organizations/{organization_id}/data
   * @secure
   */
  getOrganizationData = (organizationId, params = {}) =>
    this.http.request({
      path: `/api/admin/organizations/${organizationId}/data`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
